import React from "react";
import Meta from "./../components/Meta";
import DashboardSection from "./../components/DashboardSection";
import { requireAuth } from "./../util/auth";
//import DashboardAdmin from "./DashboardAdmin"; // Import the DashboardAdmin component


function DashboardPage(props) {
  return (
    <>
      <Meta title="Dashboard" />
      <DashboardSection
        title="Dashboard"
        subtitle="Thank you for contributing to our online library!"

        //subtitle="Books You Add Here Will Appear in the Catalog for Others to Request"
        strapline=""
        size="md"
        bgColor="bg-white"
      />
    </>
  );
}

export default requireAuth(DashboardPage);
